<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '70%'}" [baseZIndex]="10000"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false">
  <dialog-header [title]="" [settings]="settings"></dialog-header>  
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'" style="height: 70svh;">
    <div class="col-12 text-centre padding15 image-container" (wheel)="onWheel($event)" (mousedown)="startPan($event)"
      (mousemove)="onPan($event)" (mouseup)="endPan()" (mouseleave)="endPan()">
      <img [src]="image" style="max-width: inherit !important;" class="b-radius"
        [style.transform]="'scale(' + zoom + ') translate(' + translateX + 'px, ' + translateY + 'px)'"
        [style.transform-origin]="transformOrigin" alt="Zoomable image" draggable="false" />
    </div>
  </div>
  <div class="row controls" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="flex justify-centre">
      <button class="btn font18" (click)="zoomIn()" pTooltip="Zoom In" tooltipPosition="top">
        <fa-icon [icon]="faPlus" class="textGreen"></fa-icon>
      </button>
      <button class="btn font18" (click)="zoomOut()" pTooltip="Zoom Out" tooltipPosition="top">
        <fa-icon [icon]="faMinus" class="textGreen"></fa-icon>
      </button>
    </div>    
  </div>
</p-dialog>